import React from 'react'
import PropTypes from 'prop-types'
import Event from '@app/models/event'
import Tours from './Tours'
import Rewarding from './Rewarding'

const Label = ({ event }) => {
  return event.afterMainTour || event.afterPreparatoryTour ? (
    <Rewarding event={event} />
  ) : ( <Tours event={event} /> )
}

Label.propTypes = {
  event: PropTypes.instanceOf(Event).isRequired
}

export default Label
